import React from "react";
import { Container } from "styles/common/container";
import { Spacer } from "styles/common/spacer";
import {
  CardCarousel,
  ClassDetailModal,
  OngoingClassCard,
  UpcomingClassCard,
  UserNotice
} from "..";
import { NPSModal } from "components/nps/nps-modal/nps-modal";
import { useUserLanding } from "../hooks/use-user-landing/use-user-landing";
import { ClassSessionType } from "../hooks/use-user-landing/use-user-landing.types";
import { TrialActivationMessage } from "../trial-activation-modal/trial-activation-message";
import { TrialActivationComponent } from "../trial-activation-modal/trial-activation-modal.types";
import { TrialActivationStatus } from "../trial-activation-modal/trial-activation-status";
import { IFreeUserLandingProps } from "./free-user-landing.types";
import { getFeatureFlag } from "utils/utils";
import { flags } from "constants/flags";
import { PastClassesBlock } from "../past-classes-block/past-classes-block";

import { ClassSession } from "services/api/sessions/sessionService.types";
import { OnGoingClassCardTitleFreeUser } from "../ongoing-class-card/ongoing-class-card.styles";
import {
  PaidUserWeeklySchedule,
  PaidUserWeeklyScheduleButton
} from "../paid-user-landing/paid-user-mobile.styles";
import { Arrow } from "components/icons/arrow";

const FreeUserLandingLaptop: React.FC<IFreeUserLandingProps> = ({
  primaryUser,
  userSubscriptionStatus
}) => {
  const userSubscriptionType = userSubscriptionStatus.subscriptionType;

  const {
    modalClassSession,
    setClassSessionModalDetails,
    modalType,
    mediaBaseUrl,
    currentTimeStamp,
    onGoingClasses,
    upcomingClasses,
    activationState,
    showTrialActivationComponent,
    activateTrial,
    showTrialActivation,
    setShowTrialActivation,
    handleJoinClass,
    isNpsModalOpen,
    feedbackTrialClassDataObject,
    handleNpsModalClose,
    routeToWeeklySchedulePage
  } = useUserLanding(primaryUser, userSubscriptionStatus);

  const handleModalClose = () => {
    setShowTrialActivation.off();
  };

  return (
    <>
      <main>
        <Container>
          <Spacer token={[0, 0, 24]} />
          {userSubscriptionType && (
            <UserNotice
              primaryUser={primaryUser}
              subscriptionStatus={userSubscriptionStatus}
            />
          )}
          <Spacer token={[16, 16, 80]} />
          {mediaBaseUrl &&
            currentTimeStamp &&
            onGoingClasses &&
            onGoingClasses?.length > 0 && (
              <CardCarousel
                title={
                  <OnGoingClassCardTitleFreeUser>
                    Lagi berlangsung
                  </OnGoingClassCardTitleFreeUser>
                }
                onScrollToPrevPage={() => null}
                onScrollToNextPage={() => null}>
                {onGoingClasses?.map((classSession: ClassSession) => (
                  <OngoingClassCard
                    subscriptionStatus={userSubscriptionStatus}
                    key={classSession.id}
                    classSession={classSession}
                    baseMediaURL={mediaBaseUrl}
                    currentTimeStamp={currentTimeStamp}
                    primaryUser={primaryUser}
                    handleShowMoreDetails={() =>
                      setClassSessionModalDetails(
                        classSession,
                        ClassSessionType.ONGOING
                      )
                    }
                    handleJoinClass={handleJoinClass}
                  />
                ))}
              </CardCarousel>
            )}
          <Spacer token={[16, 16, 80]} />
          {upcomingClasses &&
            upcomingClasses.mandatoryClasses.length > 0 &&
            mediaBaseUrl &&
            currentTimeStamp && (
              <>
                <CardCarousel
                  title="Kelas mendatang"
                  onScrollToPrevPage={() => null}
                  onScrollToNextPage={() => null}>
                  {upcomingClasses.mandatoryClasses?.map((classSession) => (
                    <UpcomingClassCard
                      key={classSession.id}
                      classSession={classSession}
                      baseMediaURL={mediaBaseUrl}
                      currentTimeStamp={currentTimeStamp}
                      handleShowMoreDetails={() =>
                        setClassSessionModalDetails(
                          classSession,
                          ClassSessionType.UPCOMING
                        )
                      }
                    />
                  ))}
                </CardCarousel>

                <PaidUserWeeklySchedule>
                  <PaidUserWeeklyScheduleButton
                    onClick={routeToWeeklySchedulePage}
                    variant={"secondary"}>
                    Cek jadwal di minggu lain <Arrow />
                  </PaidUserWeeklyScheduleButton>
                </PaidUserWeeklySchedule>
              </>
            )}
          <Spacer token={[16, 16, 80]} />
          {upcomingClasses && upcomingClasses.extraClasses.length > 0 && (
            <CardCarousel
              title="Kelas ekstra yang akan datang"
              onScrollToPrevPage={() => null}
              onScrollToNextPage={() => null}>
              {mediaBaseUrl &&
                currentTimeStamp &&
                upcomingClasses.extraClasses?.map((classSession) => (
                  <UpcomingClassCard
                    key={classSession.id}
                    classSession={classSession}
                    baseMediaURL={mediaBaseUrl}
                    currentTimeStamp={currentTimeStamp}
                    handleShowMoreDetails={() =>
                      setClassSessionModalDetails(
                        classSession,
                        ClassSessionType.UPCOMING
                      )
                    }
                  />
                ))}
            </CardCarousel>
          )}
          <Spacer token={[16, 16, 80]} />
          {getFeatureFlag(flags.showPastSessionsBlock) && (
            <PastClassesBlock
              primaryUser={primaryUser}
              subscriptionStatus={userSubscriptionStatus}
              routeToWeeklySchedulePage={routeToWeeklySchedulePage}
            />
          )}
        </Container>
        {mediaBaseUrl && currentTimeStamp && modalClassSession && modalType && (
          <ClassDetailModal
            subscriptionStatus={userSubscriptionStatus}
            classSession={modalClassSession}
            baseMediaURL={mediaBaseUrl}
            currentTimeStamp={currentTimeStamp}
            classType={modalType}
            handleClose={() => setClassSessionModalDetails(null, null)}
            handleJoinClass={handleJoinClass}
            primaryUser={primaryUser}
          />
        )}
        <Spacer token={[8, 8, 40]} />
        {feedbackTrialClassDataObject?.id && (
          <NPSModal
            feedbackTrialClassDataObject={feedbackTrialClassDataObject}
            isOpen={isNpsModalOpen}
            onClose={handleNpsModalClose}
          />
        )}
      </main>
      {showTrialActivation &&
        showTrialActivationComponent ===
          TrialActivationComponent.TRIAL_ACTIVATION_STATUS &&
        activationState && (
          <TrialActivationStatus
            onClose={handleModalClose}
            activationState={activationState}
            daysLeft={userSubscriptionStatus.daysLeft}
          />
        )}
      {showTrialActivation &&
        showTrialActivationComponent ===
          TrialActivationComponent.TRIAL_ACTIVATION_MESSAGE && (
          <TrialActivationMessage
            onClose={() => setShowTrialActivation.off()}
            activateTrial={activateTrial}
          />
        )}
    </>
  );
};

export { FreeUserLandingLaptop };
